<section class="context-jobs-home">
  @if ((isMobileAndTabletPortrait$ | async) === false) {
    <div class="context-jobs-home__content">
      <h2 class="context-jobs-home__content__title" i18n="@@context.jobs.home.title">
        Bonjour et bienvenue sur WIZBII Jobs&nbsp;!
      </h2>
      <p class="context-jobs-home__content__subtitle" i18n="@@context.jobs.home.subtitle">
        Trouvez dès à présent votre prochain stage, alternance ou nouvel emploi&nbsp;!
      </p>
      <div class="context-jobs-home__content__card">
        <mat-icon class="context-jobs-home__content__card__icon" svgIcon="briefcase" height="3.125em" width="3.125em" />
        <p i18n="@@context.jobs.home.content-card-1">
          Plus de&nbsp;<span class="highlighted">150&nbsp;000</span>&nbsp;jobs à pourvoir
        </p>
      </div>
      <div class="context-jobs-home__content__card">
        <mat-icon class="context-jobs-home__content__card__icon" svgIcon="building" height="3.125em" width="3.125em" />
        <p i18n="@@context.jobs.home.content-card-2">
          Des&nbsp;<span class="highlighted">centaines d'entreprises</span>&nbsp;qui recrutent chaque jour
        </p>
      </div>
      <div class="context-jobs-home__content__card context-jobs-home__last-card">
        <mat-icon class="context-jobs-home__content__card__icon" svgIcon="location" height="3.125em" width="3.125em" />
        <p i18n="@@context.jobs.home.content-card-3">
          Plus de&nbsp;<span class="highlighted">100 évènements</span>&nbsp;de recrutements dans la France entière
        </p>
      </div>
    </div>
  } @else {
    <p class="context-jobs-home__pop-up" i18n="@@context.jobs.home.subtitle-mobile">
      <span class="highlighted highlighted--green">Trouvez dès à présent</span> votre prochain stage, alternance ou
      nouvel emploi&nbsp;!&nbsp;💼
    </p>
  }
</section>
